import {
  faUser,
  faVial,
  faWind,
  faPhone,
  faServer,
  faCircle,
  faFilePdf,
  faChartPie,
  faEnvelope,
  faArrowRight,
  faHeartPulse,
  faKitMedical,
  faDoNotEnter,
  faInfoSquare,
  faCircleNodes,
  faShieldCheck,
  faStethoscope,
  faHandHoldingHeart,
  faHexagonExclamation,
  faMessageExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faFacebook,
  faLinkedin,
  faXTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

// Types
import { PrismicIcon } from '@/types/styling/icons';

export const retrieveIcon = (icon: PrismicIcon): IconDefinition => {
  const mappedIcon = {
    User: () => faUser,
    Vial: () => faVial,
    Wind: () => faWind,
    PDF: () => faFilePdf,
    Phone: () => faPhone,
    Server: () => faServer,
    Default: () => faCircle,
    Email: () => faEnvelope,
    Facebook: () => faFacebook,
    LinkedIn: () => faLinkedin,
    'Chart Pie': () => faChartPie,
    'X - Twitter': () => faXTwitter,
    Stethoscope: () => faStethoscope,
    'Arrow Right': () => faArrowRight,
    'Kit Medical': () => faKitMedical,
    'Heart Pulse': () => faHeartPulse,
    'Do Not Enter': () => faDoNotEnter,
    'Circle Nodes': () => faCircleNodes,
    'Shield Check': () => faShieldCheck,
    'Information - Square': () => faInfoSquare,
    'Hand Holding Heart': () => faHandHoldingHeart,
    'Message Exclamation': () => faMessageExclamation,
    'Hexagon Exclamation': () => faHexagonExclamation,
    'Triangle Exclamation': () => faTriangleExclamation,
  }[icon]();

  return mappedIcon;
};
